import { render, staticRenderFns } from "./ProjectCreateModal.vue?vue&type=template&id=1c5b8da4&"
import script from "./ProjectCreateModal.vue?vue&type=script&lang=js&"
export * from "./ProjectCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports